// @flow

import type { ServiceSectionStatusesState } from "./types";

export const initialState: ServiceSectionStatusesState = {
  error: null,
  list: [],
};

export default initialState;
